import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { BlockedContainerProps } from '.';
import "./BlockedContainer.scss";
import { useEffect } from 'react';

export const BlockedContainer: React.FC<BlockedContainerProps> = ({children, className, style = {}, center = true, isFullScreen = true, onRequestClose, onOverlayClick, onEsc }) => {

	// Закрытие контейнера при клике на overlay
	const handleOverlayMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		if ( e.target !== e.currentTarget ) return;
		if ( onOverlayClick ) onOverlayClick();
		else if ( onRequestClose ) onRequestClose();
	};

	// Закрытие контейнера при нажатии на Esc
	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if ( e.key === 'Escape' ) {
				if ( onEsc ) onEsc();
				else if ( onRequestClose ) onRequestClose();
			}
		};
		window.addEventListener('keydown', handleKeyDown);
		return () => window.removeEventListener('keydown', handleKeyDown);
	}, [ onEsc, onRequestClose ]);

	const renderContent = () => (
		<div className={classNames("rdc_container-block", className, { "fcentered": center })} style={style} onMouseDown={handleOverlayMouseDown}>
			{children}
		</div>
	);

	return isFullScreen ? createPortal( renderContent(), document.body ) : renderContent();
}
